import './studies.settings.css';
import React, { useState } from 'react';
import TabBar from '../../../component/tab-bar/tab-bar';
import ProgramsSettingsTab from './tabs/abstract-programs/programsSettingsTab';
import SettingsEducationAbstractCourses from './tabs/asbtract-courses/settings-education-abstract-courses';
import { SettingsEducationMajorsTabs } from './tabs/mayors-types/settings-education-majors-tabs';
import { SettingsEducationAssignmentsTab } from './tabs/assignments/settings-education-assignments-tab';
import { SettingsEducationExamsTab } from './tabs/exam-types/settings-education-exams-tab';
import { SettingsEducationSupervisoryInstitutionsTab } from './tabs/supervisory-institutions/settings-education-supervisory-institutions-tab';
import { SettingsCourseStudentStatuses } from './tabs/course-student-statuses/settings-course-student-statuses';
import { SettingsEducationExternalTabs } from './tabs/external-exams/settings-education-external-tabs';

const tabs = [
  'מגמות',
  'תוכניות לימודים טיפוסיות',
  'קורסים טיפוסיים',
  'סוגי מטלות',
  'סוגי מבחנים',
  'גופים מפקחים',
  'סטטוס סטודנטים בקורס',
  'מבחנים חיצוניים',
];

const SettingsEducationPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onTabSelected = (index: number) => {
    setSelectedIndex(index);
  };

  const tabComponents = [
    <SettingsEducationMajorsTabs key="majors" />,
    <ProgramsSettingsTab key="programs" />,
    <SettingsEducationAbstractCourses key="courses" />,
    <SettingsEducationAssignmentsTab key="assignments" />,
    <SettingsEducationExamsTab key="exams" />,
    <SettingsEducationSupervisoryInstitutionsTab key="supervisory" />,
    <SettingsCourseStudentStatuses key="statuses" />,
    <SettingsEducationExternalTabs key="external" />,
  ];

  return (
    <div className={'studies-settings-root'}>
      <div style={{ width: '100%' }} className={'studies-settings-body-page'}>
        <div className={'studies-settings-title'}>הגדרות מערכת - לימודים</div>

        <TabBar
          tabs={tabs}
          onClick={(index) => {
            onTabSelected(index);
            console.log('The index ' + index + 'Is clicked');
          }}
        ></TabBar>
        {/*        <Breadcrumb
          onClick={(index) => {
            return;
          }}
          crumbs={[
            'הגדרות מערכת',
            'תוכניות לימודים טיפוסיות',
            'הנדסאי תוכנה לימודי ערב',
            'קורסים',
          ]}
        ></Breadcrumb>*/}
        {/*<DataTableContainer title={tabs[selectedIndex]} isLoading={isLoading} lazyLoading={ { columnNumber: rowsDataMock[selectedIndex][0].length, rowsNumber: 10 } } table={createTableData(rowsDataMock[selectedIndex])}/>*/}

        {tabComponents.map((component, index) => (
          <div
            key={index}
            style={{ display: selectedIndex === index ? 'block' : 'none' }}
          >
            {component}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsEducationPage;
